import React, { useEffect, useState } from 'react'
import { useDataProvider, useNotify } from 'react-admin'
import { Typography, Button as MuiButton } from '@mui/material'

export const TemplateVariables = ({ templateName, onVariableClick }) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const [variables, setVariables] = useState([])
  const [servicePushTemplates, setServicePushTemplates] = useState([])

  useEffect(() => {
    dataProvider
      .getList('servicePushTemplates', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'id', order: 'ASC' },
      })
      .then(({ data }) => setServicePushTemplates(data))
      .catch((error) => notify(`Error: ${error.message}`, { type: 'warning' }))
  }, [dataProvider, notify])

  useEffect(() => {
    if (templateName) {
      const indexServicePushTemplates = servicePushTemplates.findIndex(
        (template) => template.name === templateName
      )
      if (indexServicePushTemplates !== -1) {
        const templateVar = servicePushTemplates[indexServicePushTemplates].variables
        setVariables(templateVar)
      } else {
        setVariables([])
      }
    } else {
      setVariables([])
    }
  }, [templateName, servicePushTemplates])

  return (
    <>
      <Typography mb={1} fontSize="12px">
        Template variables
      </Typography>
      {variables.length > 0 && (
        <>
          <div style={{ marginBottom: 8 }}>
            {variables.map((variable) => (
              <MuiButton
                key={variable}
                variant="outlined"
                size="small"
                style={{ marginRight: 4, marginBottom: 4 }}
                onClick={() => onVariableClick(variable)}
              >
                {`{{${variable}}}`}
              </MuiButton>
            ))}
          </div>

          <Typography mb={2} fontSize="14px">
            Click on a variable to insert it into the text.
          </Typography>
        </>
      )}
      {!templateName && <Typography mb={2}>Please select template to see variables.</Typography>}
      {templateName && variables.length === 0 && (
        <Typography mb={2}>This template has no variables.</Typography>
      )}
    </>
  )
}
